<script>
    import Spinner from '~/components/Spinner.svelte';
    import { db, storage } from '~/firebase';
    import { createEventDispatcher } from 'svelte';
    import { v4 as uuid } from 'uuid';

    const dispatch = createEventDispatcher();

    export let files;
    export let loading = false;
    
    const uploadedFiles = [];

    let uploading = [];

    let finishedUpload = 0;
    let currentProgress = 0;

    $: totalProgress = (100 * (finishedUpload + currentProgress) / uploading.length).toFixed(2);

    $: upload(uploading);

    async function remove(file) {
        files = files.filter(f => f !== file);
        if (uploadedFiles.includes(file)) {
            await storage
                .child(file.id)
                .delete();
        }
        else {
            // Defer to parent in case editing is cancelled
            dispatch('delete', { file });
        }
    }

    async function upload() {
        loading = true;
        finishedUpload = 0;
        for (const file of uploading) {
            const id = uuid() + '/' + file.name;
            const ref = storage.child(id);
            const task = ref.put(file);
            
            for await (const { offset, total } of task) {
                currentProgress = offset / total;
            }

            finishedUpload++;
            currentProgress = 0;
            
            const newFile = {
                name: file.name,
                id,
                url: await ref.getDownloadURL(),
                visible: true
            };
            files = [...files, newFile];
            uploadedFiles.push(newFile);
        }
        loading = false;
    }

    function up(i) {
        files = [...files.slice(0, i - 1), files[i], files[i - 1], ...files.slice(i + 1)];
    }
</script>

<style lang="scss">
    .uploader {
        margin: 0.5rem 0;
        padding: 1rem 1rem;
        border: dotted 1px $link;
    }

    .flex {
        display: flex;
        align-items: baseline;
        .left {
            padding-right: 1rem;
        }
        .fill {
            flex: 1 1 auto;
        }
        .right {
            padding-left: 1rem;
        }
    }

    .center {
        display: flex;
        justify-content: center;
    }

    .hidden {
        display: none;
    }

</style>

<div class="uploader">
    {#if files.length > 0}
        <div>
            <h3>Uploaded Files</h3>
            {#each files as file, i (file.id)}
                <div class="flex">
                    <div class="left">
                        {#if i > 0}
                            <a href="javascript:void(0);" on:click={() => up(i)}>↑</a>
                        {:else}
                            ↑
                        {/if}
                        |
                        {#if i < files.length - 1}
                            <a href="javascript:void(0);" on:click={() => up(i + 1)}>↓</a>
                        {:else}
                            ↓
                        {/if}
                    </div>
                    <div class="fill">
                        <input bind:value={file.name}>
                    </div>
                    <div class="right">
                        <a href="javascript:void(0)" on:click={() => file.visible = !file.visible}>
                            {#if file.visible}
                                👁
                            {:else}
                                -
                            {/if}
                        </a> | 
                        <a href={file.url} target="_blank">↓</a> |
                        <a href="javascript:void(0)" on:click={() => remove(file)}>✕</a>
                    </div>
                </div>
            {/each}
        </div>
    {/if}

    <div class="center">
        {#if loading}
            <div>{totalProgress}%</div>
        {:else}
            <label class="button">
                Upload file(s)
                <input class="hidden" type="file" bind:files={uploading} multiple>
            </label>
        {/if}
    </div>
</div>
